<template>
    <UPopover :popper="{ placement: 'bottom-start' }" :ui="{ base: 'overflow-visible focus:outline-none relative' }" @update:open="onToggle">
        <UButton icon="i-ph-funnel-duotone" color="gray" trailing-icon="i-ph-caret-down" size="sm">Filter</UButton>

        <template #panel="{ close }">
            <div class="w-72">
                <div v-if="stage === null" class="p-1">
                    <button
                        v-for="f in filters"
                        :key="f.key.toString()"
                        type="button"
                        class="w-full flex items-center justify-between px-2 py-1.5 rounded-md hover:bg-gray-100 text-sm text-left"
                        @click="stage = f.key"
                    >
                        <span>{{ f.label }}</span>
                        <span v-if="isFilterActive(f)" class="size-1.5 rounded-full bg-primary-500" aria-hidden="true" />
                    </button>
                </div>

                <div v-else>
                    <div class="flex items-center justify-between gap-2 border-b border-gray-100 px-3 py-3">
                        <button type="button" class="flex items-center gap-1 text-xs font-medium text-gray-500 hover:text-gray-800" @click="stage = null">
                            <UIcon name="i-ph-arrow-left" /> Back
                        </button>
                        <span class="text-sm font-medium text-gray-700">{{ activeFilter?.label }}</span>
                        <button type="button" class="text-xs text-red-500 hover:text-red-700" @click="clearActive(close)">Clear</button>
                    </div>
                    <div class="p-3">
                        <OverlayFiltersFilterInput v-if="activeFilter" :filter="activeFilter" @update:filter="onUpdate" />
                    </div>
                </div>
            </div>
        </template>
    </UPopover>
</template>

<script setup lang="ts">
import { type FilterType, type Filter } from '~/types/filter'
import { isFilterActive } from '~/utils/filter-chip-summary'

const props = defineProps<{ filters: Filter[] }>()
const emit = defineEmits<{ 'update:filters': [Filter[]] }>()

const stage = ref<FilterType | null>(null)
const activeFilter = computed(() => props.filters.find(f => f.key === stage.value) ?? null)

function onToggle(open: boolean) {
    if (!open) stage.value = null
}

function onUpdate(updated: Filter) {
    emit('update:filters', props.filters.map(f => (f.key === updated.key ? updated : f)))
}

function clearActive(close: () => void) {
    if (activeFilter.value) onUpdate({ ...activeFilter.value, value: undefined, selected: undefined })
    stage.value = null
    close()
}
</script>
